import { Box } from 'components/Material/index'

type Props = {
  src: string
  children: React.ReactNode
  className?: string
  alt?: string
}

export const BackgroundImage = ({ src, children, className, alt }: Props) => {
  return (
    <Box
      className={className}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        overflow: 'hidden'
      }}
    >
      {children}
    </Box>
  )
}
